import { Injectable } from "@angular/core";
import { ContentLanguageComponent } from "./content-language-utils";
import { i18nLanguages } from "@app/core/constants/i18n-languages";
import { CurrentTenant } from "@app/core/models/CurrentTenant";

@Injectable({
    providedIn: "root",
})


export class DateFormatUtils {
    userLanguage: CurrentTenant

    constructor(private language: ContentLanguageComponent) {
        this.getCurrentLanguage()
    }

    public async getCurrentLanguage() {
        const currentLanguage = await this.language.getLanguage()
        this.userLanguage = currentLanguage
    }

    public getDateFormat(): string {
        if (this.userLanguage) {
            if (i18nLanguages[this.userLanguage.language] === 'pt-BR') {
                return 'dd/MM/yyyy HH:mm'
            }
            return 'MM/dd/yyyy hh:mm a'
        }
    }

    public isBraziliamFormat(): boolean {
        if (this.userLanguage) {
            if (i18nLanguages[this.userLanguage.language] === 'pt-BR') {
                return true
            }
            return false
        }
    }

}